import React, { useState } from 'react';
import { Form, Transition, Document } from 'components';
import { api, cookies, delay, config } from 'helpers';
import { errors } from '.';
import css from './short.scss';

export function RestoreEnter(props) {
  const [ state, setState ] = useState({});

  async function submit({ values, setError, setPending, setSuccess, redirect }) {
    if (!values.password) {
      return setError('password', 'please enter your password');
    } else if (values.password.length < 6) {
      return setError('password', 'must be at least 6 characters');
    } else if (values.password.length > 15) {
      return setError('password', 'must be no longer than 15 characters');
    } else if (values.password != values.password2) {
      return setError('password2', 'entered passwords do not match');
    }

    setPending();

    try {
      cookies.remove('token', { domain: config.appHost });
      cookies.remove('signing-up', { domain: config.appHost });

      await api('/set-new-password/', {
        password: values.password,
        confirm: values.password2,
        code: props.option,
      });

      setSuccess();

      await delay(2000);

      redirect('/login/');

    } catch ({ error }) {
      setError('password', errors[error] || 'Error. Please try again');
    }

    setPending(false);
  }

  return (
    <Transition in={props.active} mountOnEnter unmountOnExit classNames={css.locals} timeout={500}>
      <Form onSubmit={submit} state={state} setState={setState} className={css('form', 'appear'+props.status)} autoComplete="off">
        <Document.Title>Restore Password</Document.Title>
        <p><Form.Password name="password" label="Password" /></p>
        <p className={css.tip}>*must be at least 6 and no longer than 15 characters</p>
        <p><Form.Password name="password2" label="Confirm password" /></p>
        <p><Form.Submit>Set New Password</Form.Submit></p>
        { state.success &&
          <div className={css.cover}>
            <p>New password has been set! Redirecting now..</p>
          </div>
        }
      </Form>
    </Transition>
  );
}
